import { Badge } from '@mantine/core'
import { useT } from '../../hooks'

/**
 * One map decides status colour everywhere. Colour is never the only signal: the label text is
 * always rendered. green = good, yellow = waiting, orange = needs action, red = bad,
 * grey = inactive, cobalt = in progress.
 */
export const statusMeta = {
  draft: 'gray',
  submitted: 'brand',
  in_review: 'brand',
  corrections_requested: 'orange',
  approved: 'green',
  rejected: 'red',
  cancelled: 'gray',
  awaiting_release: 'yellow',
  active: 'green',
  completed: 'green',
  defaulted: 'red',
  upcoming: 'gray',
  due: 'orange',
  partial: 'yellow',
  paid: 'green',
  overdue: 'red',
  pending: 'yellow',
  verified: 'green',
  reversed: 'gray',
}

export default function StatusBadge({ status }) {
  const t = useT()
  if (!status) return null
  return <Badge color={statusMeta[status] || 'gray'}>{t(`status_${status}`)}</Badge>
}
